const DEFAULT_POLL_MS =
  process.env.REACT_APP_ENV != "prod" ? 60 * 1000 : 5 * 60 * 1000;

export const createVersionUpdateManager = (options) => {
  const {
    getUpdateAvailable,
    onInitialVersion,
    onUpdateAvailable,
    pollIntervalMs = DEFAULT_POLL_MS,
    versionUrl = "/version.json",
    storageKey = "appBuildVersion",
  } = options;

  let intervalId = null;

  const checkForVersionUpdate = async () => {
    console.log("Checking for version update...");
    try {
      const response = await fetch(`${versionUrl}?ts=${Date.now()}`, {
        cache: "no-store",
      });
      if (!response.ok) {
        return;
      }

      const data = await response.json();
      const latest = data && data.version ? data.version : "";
      if (!latest) {
        return;
      }

      const stored = localStorage.getItem(storageKey);
      if (!stored) {
        localStorage.setItem(storageKey, latest);
        if (onInitialVersion) {
          onInitialVersion(latest);
        }
        return;
      }

      const updateAlreadyShown = getUpdateAvailable
        ? getUpdateAvailable()
        : false;
      if (stored !== latest && !updateAlreadyShown) {
        if (onUpdateAvailable) {
          onUpdateAvailable(latest);
        }
      }
    } catch (error) {
      // Swallow version check errors.
    }
  };

  const start = () => {
    console.log("Version manager started");
    checkForVersionUpdate();
    intervalId = setInterval(checkForVersionUpdate, pollIntervalMs);
  };

  const stop = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  return {
    start,
    stop,
  };
};
